module.exports = __webpack_public_path__ + "img/home_bg_left.d08cdc8e.png";